import textStyle from './treemap.breadcrumb.itemStyle.textStyle'

export default {
  name: "itemStyle",
  nickname: "项样式",
  desc: " 图形样式。",
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc: "boxplot图形的颜色。",
      value: "rgba(0,0,0,0.7)",
      defaultValue: "rgba(0,0,0,0.7)",
      type: "pureValue",
      eType: "color",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc:
        'boxplot图形的描边颜色。支持的颜色格式同 <code class="codespan">color</code>，不支持回调函数。',
      value: "rgba(255,255,255,0.7)",
      defaultValue: "rgba(255,255,255,0.7)",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "boxplot描边线宽。为 0 时无描边。",
      value: 1,
      defaultValue: 1,
      type: "pureValue",
    },
    borderType: {
      name: "borderType",
      nickname: "边框类型",
      desc:
        '柱条的描边类型，默认为实线，支持 <code class="codespan">&#39;solid&#39;</code>, <code class="codespan">&#39;dashed&#39;</code>, <code class="codespan">&#39;dotted&#39;</code>。',
      value: "solid",
      defaultValue: "solid",
      type: "pureValue",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
      value: 3,
      defaultValue: 3,
      type: "pureValue",
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
      value: "rgba(150,150,150,1)",
      defaultValue: "rgba(150,150,150,1)",
      type: "pureValue",
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    opacity: {
      name: "opacity",
      nickname: "透明度",
      desc: "图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。",
    },
    textStyle,
  },
}
